var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgComanBackground = function SvgComanBackground(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 957,
    height: 765,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#107A66",
    d: "M0 0h957v765H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.05,
    d: "M100.665 465.652c31.413-54.715 89.137-84.979 151.264-54.308 64.03 20.106 193.075 83.367 197.014 175.565 4.925 115.248-105.911 228.864-164.799 230.158-54.485 1.196-93.23-43.43-99.739-72.251-13.29-58.844-10.99-81.257-65.698-101.424-86.198-31.774-53.1-116.674-18.042-177.74ZM552.681 564.497c5.288-10.018 32.305-46.485 80.043-42.761 101.871 13.944 131.491 153.792 112.388 204.018-19.102 50.226-83.301 75.567-120.336 72.713-37.036-2.853-77.244-53.596-102.057-91.905-19.851-30.647-5.984-97.476 29.962-142.065Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.05,
    fillRule: "evenodd",
    d: "M0 468.702c41.105-33.886 55.755-88.377 57.19-123.589C55.027 315.485 34.463 271.041 0 230.155v238.547Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.05,
    d: "M1014.19 345.113c-2.4 58.894-41.769 171.718-180.049 151.867-102.708-14.745-108.458-153.863-174.505-137.288-127.301 31.948-178.237 1.263-187.672-68.909-9.434-70.171 32.811-101.288 141.799-148.263 173.198-74.65 243.329-3.002 304.695 48.943 57.41 48.597 92.852 114.234 95.732 153.65ZM552.681-199.503c5.288-10.018 32.305-46.485 80.043-42.761C734.595-228.32 764.215-88.472 745.112-38.246 726.01 11.98 661.811 37.321 624.776 34.467c-37.036-2.853-77.244-53.596-102.057-91.905-19.851-30.647-5.984-97.476 29.962-142.065ZM100.665-299.348c31.413-54.715 89.137-84.979 151.264-54.308 64.03 20.106 193.075 83.367 197.014 175.565C453.868-62.843 343.032 50.773 284.144 52.067c-54.485 1.196-93.23-43.43-99.739-72.251-13.29-58.844-10.99-81.257-65.698-101.424-86.198-31.774-53.1-116.674-18.042-177.74Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h957v765H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgComanBackground);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "coman-background.2f2aca62b4eed7bdee67cdcea5af0336.svg";